import { render, staticRenderFns } from "./EmployeeRequests.vue?vue&type=template&id=87a1d79a&scoped=true"
import script from "./EmployeeRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeRequests.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRequests.vue?vue&type=style&index=0&id=87a1d79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a1d79a",
  null
  
)

export default component.exports